import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

let idHotsiteLocalStorage = getlocalStorageIdHotsite();


export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage,
  Loja: "intercam",
  UserStorage: "LJtff8guGUGkBFMmGszOwg==",
  UserToken: "Qq1rWi9DaEWxjHUm44BrLg==",
  UrlApi: "https://prd-ecommerce-int-api.primecase.com.br/api",
  // UrlApi: "https://localhost:44388/api",
  UrlLoja:"https://prd-int-ste-web.primecase.com.br/",
  UrlServiceHost: "https://prd-int-svc-api.primecase.com.br/",
  //UrlServiceHost: "https://localhost:52777/",
  OrgId: "",
  ProviderMerchantId: ""
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#d9ab00",
      light: "#d9ab00",
      //lighter: "#ece6f7",
      dark: darkenColor("#d9ab00", 10), // Escurece em 20%
    },
    secondary: {
      main: "#db2f2f",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
